import { FormErrors } from './types';

export function scrollToFirstError<T>(errors: FormErrors<T>): void {
  const firstErrorField = Object.keys(errors)[0];
  if (!firstErrorField) return;

  const element = document.querySelector(`[data-field="${firstErrorField}"]`);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const input = element.querySelector('input');
    input?.focus({ preventScroll: true });
  }
}
